<script>
  import liberarPagamento from '../servico';
  import Paginacao from '~componentes/Paginacao.vue';
  import Radio from '~componentes/Radio.vue';
  import { checkbox } from 'vue-strap';
  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';
  import projetoServico from '~modulos/projeto/servico';
  import DatePicker from 'vue2-datepicker';
  import tipoUsuario from '~js/tipo-usuario';
  import ModalDetalheLancamento from './ModalDetalheLancamento.vue';
  import ModalConfirmarLiberacao from './ModalConfirmarLiberacao.vue';

  export default {
    name: 'LiberarPagamentoLista',
    components: {
      Paginacao,
      Radio,
      checkbox,
      DatePicker,
      ModalDetalheLancamento,
      ModalConfirmarLiberacao,
    },
    data() {
      return {
        registros: [],
        carregando: false,
        pagina: 1,
        totalRegistros: 0,
        totalPaginas: 0,
        registrosPorPagina: 0,
        animated: true,
        configuracao: this.$storage.configuracao(),
        usuario: this.$storage.usuario(),
        filtros: this.camposFiltros(),
        projetos: [],
        selecionarTudo: '0',
        modalDetalhe: false,
        modalConfirmar: false,
        lancamentoSelecionado: null,
        lancamentoParaLiberar: null,
        salvandoLiberacao: false,
      }
    },
    methods: {
      camposFiltros() {
        return {
          idProjeto: '0',
          idLancamento: '',
          historico: '',
          situacao: '1',
          periodo: '',
        };
      },
      listaDeProjetos() {
        return projetoServico
          .listaDeProjetosPermissao('LiberarPagamento')
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      resetarPaginacao() {
        if (this.$refs.paginacao) {
          this.$refs.paginacao.selected = 0;
        }
      },
      filtrar() {
        this.resetarPaginacao();
        this.lista(1);
      },
      limparFiltros() {
        this.filtros = this.camposFiltros();
        this.$nextTick(() => {
          $('#projeto').val(0).trigger('change.select2');
        });
        this.selecionarTudo = '0';
        this.resetarPaginacao();

        this.lista(1);
      },
      mostrarEsconderFiltro(e) {
        if (!$(e.target).hasClass('fa-chevron-down') && !$(e.target).hasClass('fa-chevron-up')) {
          $('.collapse-link').trigger('click');
        }
      },
      lista(pagina = 1) {
        this.pagina = pagina;
        this.carregando = true;
        this.selecionarTudo = '0';

        return liberarPagamento.lista(pagina, this.filtros)
          .then(dados => {
            this.carregando = false;

            this.registros = dados.registros;
            this.totalRegistros = dados.totalRegistros;
            this.totalPaginas = dados.totalPaginas;
            this.registrosPorPagina = dados.registrosPorPagina;

            if (this.registros.length === 0 && this.pagina > 1) {
              this.lista(this.pagina - 1);
            }
          })
          .catch(erro => {
            this.carregando = false;
            this.$mensagemErro(erro, 'Erro ao carregar a lista.');
          });
      },
      status(registro) {
        if (registro.situacao === 2) return 'Liberado';
        if (registro.situacao === 3) return 'Cancelado';

        return 'Pendente';
      },
      selecionar() {
        for (let i = 0; i < this.registros.length; i++) {
          if (this.selecionarTudo === '1') {
            if (!this.registros[i].disabledSelecionado) {
              this.$set(this.registros[i], 'selecionado', '1');
            }
          } else {
            this.$set(this.registros[i], 'selecionado', '0');
          }
        }
      },
      detalhes(registro) {
        this.lancamentoSelecionado = registro.idLancamentoCrypt;
        this.modalDetalhe = true;
      },
      detalheFechado() {
        this.animated = false;
        this.modalDetalhe = false;
        this.lancamentoSelecionado = null;
      },
      confirmarLiberacaoSelecionados() {
        if (!this.podeLiberarPagamento) return;

        if (this.quantidadeSelecionada === 0) {
          this.$swal('', 'É necessário selecionar pelo menos um rateio para liberação.', 'info');
          return;
        }

        this.lancamentoParaLiberar = null;
        this.modalConfirmar = true;
      },
      confirmarLiberacaoLancamento(detalhe) {
        if (!this.podeLiberarPagamento || !detalhe) return;

        this.lancamentoParaLiberar = detalhe.idLancamentoCrypt;
        this.modalConfirmar = true;
      },
      confirmarFechado() {
        this.animated = false;
        this.modalConfirmar = false;
      },
      liberar() {
        this.salvandoLiberacao = true;
        this.modalConfirmar = false;

        const promise = this.lancamentoParaLiberar
          ? liberarPagamento.liberarLancamento(this.lancamentoParaLiberar, '')
          : liberarPagamento.liberarSelecionados(this.registros, '');

        return promise
          .then(() => {
            this.salvandoLiberacao = false;
            this.lancamentoParaLiberar = null;
            this.modalDetalhe = false;
            this.lancamentoSelecionado = null;

            toastr.success('Pagamento liberado com sucesso.');
            $('body').removeClass('modal-open');

            this.lista(this.pagina);
          })
          .catch(erro => {
            this.salvandoLiberacao = false;
            this.lancamentoParaLiberar = null;

            this.$mensagemErro(erro, 'Erro ao tentar liberar o pagamento.');
          });
      },
      gerarExcel() {
        $('#gerar-excel').button('loading');

        return liberarPagamento
          .excel(this.filtros)
          .then(arquivo => {
            $('#gerar-excel').button('reset');

            if (arquivo === '') {
              this.$swal('', 'Nenhum resultado encontrado.', 'info');
            } else {
              arquivo.download();
            }
          })
          .catch(erro => {
            $('#gerar-excel').button('reset');

            this.$mensagemErro(erro, 'Erro ao gerar relatório em excel.');
          });
      },
    },

    created() {
      const situacao = this.$route.query.situacao;
      if (['0', '1', '2', '3'].includes(situacao)) {
        this.filtros.situacao = situacao;
      }

      this.lista();
    },

    mounted() {
      this.$root.tituloDaPagina = 'Liberar Pagamento - Lista';
      this.$root.botaoAcaoTexto = '';
      this.$root.botaoAcaoMostrar = false;

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      this.listaDeProjetos();

      const _this = this;

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
        .change(function (e) {
          _this.$set(_this.filtros, 'idProjeto', this.value);
        });

      $('.ibox').removeClass('collapsed');
    },
    watch: {
      "selecionarTudo": "selecionar"
    },
    computed: {
      podeLiberarPagamento() {
        const permissoes = (this.usuario && this.usuario.permissoes) || {};

        return this.usuario.tipoUsuario === tipoUsuario.Coordenador && permissoes.liberarPagamento;
      },
      quantidadeSelecionada() {
        return this.registros.filter(registro => registro.selecionado === '1').length;
      },
      visibilidadeBotaoLiberar() {
        return this.podeLiberarPagamento && this.quantidadeSelecionada > 0;
      },
      totalColunas() {
        return this.podeLiberarPagamento ? 14 : 13;
      },
    }
  }
</script>

<template>
  <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">
    <modal-detalhe-lancamento :mostrar="modalDetalhe"
                              :id="lancamentoSelecionado"
                              :pode-liberar="podeLiberarPagamento"
                              @fechado="detalheFechado"
                              @liberar="confirmarLiberacaoLancamento">
    </modal-detalhe-lancamento>

    <modal-confirmar-liberacao :mostrar="modalConfirmar"
                               :salvando="salvandoLiberacao"
                               :quantidade="lancamentoParaLiberar ? 1 : quantidadeSelecionada"
                               @fechado="confirmarFechado"
                               @liberar="liberar">
    </modal-confirmar-liberacao>

    <div class="row">
      <div class="col-lg-12">
        <div class="ibox collapsed float-e-margins">
          <div class="ibox-title pointer" @click="mostrarEsconderFiltro">
            <h5>Filtrar lista <small class="m-l-sm">Clique para mostrar ou esconder os filtros</small></h5>

            <div class="ibox-tools">
              <span class="collapse-link">
                <i class="fa fa-chevron-up"></i>
              </span>
            </div>
          </div>
          <div class="ibox-content">

            <div class="row">
              <div class="col-xs-4">
                <div class="form-group">
                  <label class="control-label" for="projeto">Projeto</label>

                  <select id="projeto"
                          class="form-control"
                          v-model="filtros.idProjeto">
                    <option value="0">Todos</option>
                    <option :value="projeto.idProjeto" v-for="(projeto) in projetos">{{ projeto.nomeProjeto }}</option>
                  </select>
                </div>
              </div>

              <div class="col-xs-4">
                <div class="form-group">
                  <label class="control-label block">Período</label>

                  <date-picker v-model="filtros.periodo"
                               input-class="form-control"
                               range
                               :editable="false"
                               lang="pt-br"
                               :confirm="true"
                               range-separator="a"
                               format="DD/MM/YYYY"
                               :shortcuts="false">
                  </date-picker>
                </div>
              </div>

              <div class="col-xs-2">
                <div class="form-group">
                  <label class="control-label" for="idLancamento">ID do lançamento</label>
                  <input id="idLancamento"
                         type="text"
                         class="form-control"
                         v-model="filtros.idLancamento">
                </div>
              </div>

              <div class="col-xs-2">
                <div class="form-group">
                  <label class="control-label" for="historico">Histórico</label>
                  <input id="historico"
                         type="text"
                         class="form-control"
                         v-model="filtros.historico">
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label class="control-label block">Mostrar</label>

                  <radio v-model="filtros.situacao"
                         selected-value="1"
                         type="success"
                         :inline="true"
                         class="margin-right-10">
                    Pendentes
                  </radio>
                  <radio v-model="filtros.situacao"
                         selected-value="2"
                         type="success"
                         :inline="true"
                         class="margin-right-10">
                    Liberados
                  </radio>
                  <radio v-model="filtros.situacao"
                         selected-value="3"
                         type="success"
                         :inline="true"
                         class="margin-right-10">
                    Cancelados
                  </radio>
                  <radio v-model="filtros.situacao"
                         selected-value="0"
                         type="success"
                         :inline="true">
                    Todos
                  </radio>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group no-margins">
                  <button type="button" class="btn btn-success no-margins" @click="filtrar">
                    <i class="fa fa-search"></i>
                    Filtrar
                  </button>
                  <button type="button" class="btn btn-default no-margins" @click="limparFiltros">
                    <i class="fa fa-eraser"></i>
                    Limpar filtros
                  </button>
                  <button id="gerar-excel"
                          type="button"
                          class="btn btn-primary no-margins"
                          @click="gerarExcel"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
                    <i class="fa fa-table"></i>
                    Gerar listagem em excel
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="ibox-footer">
            <div class="table-responsive">
              <table class="table table-bordered table-column-code table-column-action">
                <thead>
                  <tr>
                    <th>Lançamento</th>
                    <th>Emissão</th>
                    <th>Vencimento</th>
                    <th>Pagamento</th>
                    <th>Documento</th>
                    <th>Histórico</th>
                    <th>Complemento</th>
                    <th>Projeto</th>
                    <th>Rubrica</th>
                    <th>Subrubrica</th>
                    <th class="text-right">Valor</th>
                    <th>Situação</th>
                    <th></th>
                    <th class="coluna-selecao" v-if="podeLiberarPagamento">
                      <checkbox class="ckbselecionado" value="0" type="success" true-value="1" false-value="0" v-model="selecionarTudo">
                      </checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(registro, index) in registros">
                    <td>{{ registro.idLancamento }}</td>
                    <td>{{ registro.dataEmissao | formatarData('---') }}</td>
                    <td>{{ registro.dataVencimento | formatarData('---') }}</td>
                    <td>{{ registro.dataPagamento | formatarData('---') }}</td>
                    <td>{{ registro.documentoReceberPagar || '---' }}</td>
                    <td>{{ registro.historico || '---' }}</td>
                    <td>{{ registro.complemento || '---' }}</td>
                    <td>{{ registro.nomeProjeto || '---' }}</td>
                    <td>{{ registro.nomeRubrica || '---' }}</td>
                    <td>{{ registro.nomeSubrubrica || '---' }}</td>
                    <td class="text-right">{{ registro.valor | formatarNumero }}</td>
                    <td>{{ status(registro) }}</td>
                    <td class="action">
                      <button type="button"
                              class="btn btn-default btn-xs"
                              v-tooltip="'Ver dados do lançamento'"
                              @click="detalhes(registro)">
                        <i class="fa fa-search"></i>
                      </button>
                    </td>
                    <td class="coluna-selecao" v-if="podeLiberarPagamento">
                      <checkbox class="ckbselecionado"
                                v-if="!registro.disabledSelecionado"
                                v-model="registro.selecionado"
                                value="1"
                                type="success"
                                true-value="1"
                                false-value="0">
                      </checkbox>
                    </td>
                  </tr>
                  <tr v-if="registros.length === 0 && !carregando">
                    <td :colspan="totalColunas" class="text-center">Nenhum registro encontrado.</td>
                  </tr>
                  <tr v-show="carregando">
                    <td :colspan="totalColunas">
                      <i class='fa fa-spinner fa-pulse'></i> Carregando...
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="row">
              <div class="col-xs-12 text-right">
                <button class="btn btn-primary"
                        v-tooltip="'Liberar pagamento'"
                        v-if="visibilidadeBotaoLiberar"
                        :disabled="salvandoLiberacao"
                        @click="confirmarLiberacaoSelecionados">
                  <i class="fa fa-check"></i> Liberar pagamento
                </button>
              </div>
            </div>

            <paginacao :page-count="totalPaginas"
                       :click-handler="lista"
                       :per-page="registrosPorPagina"
                       :register-count="totalRegistros"
                       :show-counter="true"
                       ref="paginacao">
            </paginacao>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .table td {
    vertical-align: middle;
  }

  .coluna-selecao {
    width: 40px;
    text-align: center;
  }

  .ckbselecionado {
    display: inline-block;
    margin: 0;
    padding-left: 0;
    min-height: 0;
  }

  .ckbselecionado >>> .icon {
    position: relative;
    top: auto;
    left: auto;
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/liberar-pagamento/componentes/LiberarPagamentoLista.vue